import { ClipboardPaste } from 'lucide-react'
import React from 'react'
import { t } from '../../locales/translate'

function PastePlanButton({onClick}) {
  return (
    <div>
      <button className='paste-plan-button' onClick={onClick}>
        <ClipboardPaste size={16} />
        <p className='paste-plan-title'>{t("pastePlan")}</p>
      </button>
    </div>
  )
}

export default PastePlanButton